import styled from 'styled-components'
import { StyledTitle } from './Title.styles'

export const ModalTitle = styled(StyledTitle)`
  color: ${({ theme }) => theme.fontFamily.secondary};
  text-align: center;
  font-family: '${({ theme }) => theme.fontFamily.secondary}';
  text-transform: none;
`
